<template>
    <div class="content">
        <div class="top">
             <van-form @submit="onSubmit">
            <van-field
                v-model="username"
                name="username"
                label="备注名"
                placeholder="请输入备注名称"
                clearable
                class="borderBottom"
                >
            </van-field>
            <van-field
                v-model="userphone"
                name="userphone"
                label="手机号"
                type="tel"
                placeholder="请输入手机号"
                @blur="blurtest('userphone')"
                @focus="focustest('userphone')"
                clearable
                class="borderBottom"
                >
                <template #button>
                    <div class="phoneRight" >
                        <span class="red buttonText" v-if="userphoneShow && userphone!==''">手机号码格式错误</span>
                        <!-- <span class="red buttonText" v-if="userphone!==''" @click="clearVal('userphone')"><van-icon  name="clear" color="#999"/></span> -->
                    </div>
                </template>
            </van-field>
            <van-field
                v-model="describe"
                name="describe"
                label="描述"
                placeholder="请输入内容"
                clearable
                autosize
                rows="1"
                type="textarea"
                >
            </van-field>
            <van-button class="bgRed" round block native-type="submit">完成</van-button>
        </van-form>
        </div>
    </div>
</template>

<script>
import { Toast } from 'vant';
export default {
    data() {
        return {
            info:"",
            username:this.$store.state.clientInfo ? this.$store.state.clientInfo.name : '',
            userphone: this.$store.state.clientInfo ? this.$store.state.clientInfo.tel : '',
            describe:this.$store.state.clientInfo ? this.$store.state.clientInfo.remark : '',
            userphoneShow:false,
            userphoneReg: /^1[3456789]\d{9}$/,
        };
    },
    created(){
        document.title="设置备注";
        this.info=this.$route.query.info;
    },
    methods: {
        focustest(val){
            this[val+'Show']=false;
        },
        blurtest(val){
            if(this[val+'Reg'].test(this[val])){
                this[val+"Show"]=false;
            }else{
                this[val+"Show"]=true;
            }
        },
        clearVal(e){
            this[e]=""
        },
       
        onSubmit(values) {
            console.log(values);
            this.$https.fetchPost("user/setUserRemark",{"id":this.$store.state.clientInfo.id,"name":values.username,"tel":values.userphone,"remark":values.describe},{headers:{"XX-Token":this.$store.state.token}})
            .then(result=>{
                let data=result.data;
                if(data.code==1){  
                    let info=this.$store.state.clientInfo;
                        info.name=values.username;
                        info.tel=values.userphone;
                        info.remark=values.describe;
                        this.$store.commit('SET_CLIENTINFO',info);
                        this.$router.go(-1);
                }else{
                    Toast(data.msg);
                }
            })
        },
    },
    computed:{
    }
}
</script>

<style scoped>
    .content{
        position: relative;
        /* top: 0;
        bottom: 0; */
        width: 100vw;
        height: 100vh;
    }
    .top{
        padding-top:10px;
    }
    .bgRed{
        width: 340px;
        height: 45px;
        color: #fff;
        background:linear-gradient(-270deg,rgba(243,71,64,1),rgba(251,149,138,1));
        position: absolute;
        bottom: 30%;
        left: 50%;
        transform: translate(-50%, 0);
        font-size: 16px;
    }
    .borderBottom{
        border-bottom: 1px solid #ebebeb;
    }
    .van-form{
        /* margin:0 15px; */
        text-align: start;
        padding: 0  15px;
        text-align: start;
        background: #fff;
        min-height: 250px;
    }
    .van-cell{
        padding: 13px 0;
    }

      .van-cell /deep/ .van-cell__value /deep/ .van-field__body{
          width: 100%;
      }
      .van-cell /deep/ .van-cell__value /deep/ .van-field__body>input{
          font-size: 14px;
      }
    .van-cell /deep/ .van-field__label{
        width: 65px;
        font-size: 14px;
        color: #666;
    }
    .van-cell  /deep/ .van-field__control input{
        font-size: 14px;;
    }
    .buttonText{
        width: 60px;
        text-align: center;
        font-size: 12px;
    }
    .rightWidth{
        display: inline-block;
        width: 70px;
        text-align: center;
    }
    .line{
        border-left:1px solid rgba(241,240,240,1);
        margin:0 5px
    }
    .van-icon{
        top:2px;
    }
    .phoneRight{
        height: 24px;
    }
</style>



// WEBPACK FOOTER //
// src/views/agentMy/noteInfo.vue